__turbopack_context__.v({
  "actions": "ui-module__35jSCq__actions",
  "amountLg": "ui-module__35jSCq__amountLg",
  "block": "ui-module__35jSCq__block",
  "button": "ui-module__35jSCq__button",
  "cellSub": "ui-module__35jSCq__cellSub",
  "chev": "ui-module__35jSCq__chev",
  "choice": "ui-module__35jSCq__choice",
  "choices": "ui-module__35jSCq__choices",
  "codeInput": "ui-module__35jSCq__codeInput",
  "crumbs": "ui-module__35jSCq__crumbs",
  "danger": "ui-module__35jSCq__danger",
  "divider": "ui-module__35jSCq__divider",
  "empty": "ui-module__35jSCq__empty",
  "error": "ui-module__35jSCq__error",
  "field": "ui-module__35jSCq__field",
  "fieldError": "ui-module__35jSCq__fieldError",
  "form": "ui-module__35jSCq__form",
  "hideNarrow": "ui-module__35jSCq__hideNarrow",
  "hint": "ui-module__35jSCq__hint",
  "info": "ui-module__35jSCq__info",
  "input": "ui-module__35jSCq__input",
  "kv": "ui-module__35jSCq__kv",
  "kvInner": "ui-module__35jSCq__kvInner",
  "label": "ui-module__35jSCq__label",
  "lead": "ui-module__35jSCq__lead",
  "line": "ui-module__35jSCq__line",
  "linkButton": "ui-module__35jSCq__linkButton",
  "newMark": "ui-module__35jSCq__newMark",
  "note": "ui-module__35jSCq__note",
  "num": "ui-module__35jSCq__num",
  "ok": "ui-module__35jSCq__ok",
  "page": "ui-module__35jSCq__page",
  "pageTitle": "ui-module__35jSCq__pageTitle",
  "pre": "ui-module__35jSCq__pre",
  "primary": "ui-module__35jSCq__primary",
  "prose": "ui-module__35jSCq__prose",
  "row": "ui-module__35jSCq__row",
  "rowAmount": "ui-module__35jSCq__rowAmount",
  "rowEnd": "ui-module__35jSCq__rowEnd",
  "rowMain": "ui-module__35jSCq__rowMain",
  "rowSub": "ui-module__35jSCq__rowSub",
  "rowTitle": "ui-module__35jSCq__rowTitle",
  "rows": "ui-module__35jSCq__rows",
  "section": "ui-module__35jSCq__section",
  "sectionBody": "ui-module__35jSCq__sectionBody",
  "sectionHeader": "ui-module__35jSCq__sectionHeader",
  "sectionLink": "ui-module__35jSCq__sectionLink",
  "sectionTitle": "ui-module__35jSCq__sectionTitle",
  "stack": "ui-module__35jSCq__stack",
  "status": "ui-module__35jSCq__status",
  "steps": "ui-module__35jSCq__steps",
  "table": "ui-module__35jSCq__table",
  "warn": "ui-module__35jSCq__warn",
});
